/** 
 * [Ref] - Denotes Pseudo Code Reference
 * Author: Sushmitha
 * Created Date: 08/11/2020
 * 
 * Import the necessary node-modules. If any of the nodes modules are not avaialble then 
 * install the node modules using the npm install command.
 * 
 * Ref: SC_PC_57
*/
import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as CookieService from '../CookieService';
import * as MenuAction from './MenuAction';
import * as $ from 'jquery';
//import axios from 'axios';
const tokenExpired = async () => {
    try {
        let tokenExpiredData = { type: "Token_Expired", response: true };
        Dispatcher.dispatch(tokenExpiredData);

    } catch (ex) {
        console.log(ex)

    }
};
/**
 * Ref: SC_PC_58
 * 
 * Getcartitem method gets called the LoadCartItem()
 * @param GetCartBO
 */
const Getcartitem = (GetCartBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_Pageload,
            JSON.stringify(GetCartBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Cartitem", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/*'[10/04/22,WW-521_13-Rating submission], Priyanka D */
const RatingSubmission = (RatingSubmissionBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_RatingSubmission,
            JSON.stringify(RatingSubmissionBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "RatingSubmissionresponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const Gettrucklatlong = (ZipcodeBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_ZipCodeLatLong,
            JSON.stringify(ZipcodeBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "latlongresp", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Ref: SC_PC_58
 * 
 * UpdateItemDesp method gets called the LinelevelEmyEdit()
 * @param UpdateItemDetails
 */
const UpdateItemDesp = (UpdateItemDetails) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_UpdateLineLevelItem,
            JSON.stringify(UpdateItemDetails),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "UpdateStatus", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Ref: SC_PC_62
 * 
 * UpdateCartEmpCC method gets called the BindEmpCCToItemOL()
 * @param UpdateOrderBO
 */
const UpdateCartEmpCC = (UpdateOrderBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_UpdateFieldLevelItem,
            JSON.stringify(UpdateOrderBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "UpdateStatusOL", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Ref: SC_PC_98
 * GetAddFavItemDetail method gets called the LinelevelFavEdit()
 * @param GetAddFavItemDetailBO
 */
const GetAddFavItemDetail = (GetAddFavItemDetailBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_GetAddToFavItemDetails,
            JSON.stringify(GetAddFavItemDetailBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "FavItemDetails", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Ref: SC_PC_99
 * updateFavsMenu method gets called the AddFavItem()
 * @param updateFavsMenuBO
 */
const updateFavsMenu = (updateFavsMenuBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_updateFavs,
            JSON.stringify(updateFavsMenuBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "FavItemUpdate", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Ref: SC_PC_58
 * 
 * DeleteCartItem method gets called the DeleteItemConfirmed()
 * @param DeleteCartItemBO
 */
const DeleteCartItem = (DeleteCartItemBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_DeleteFromUserCart,
            JSON.stringify(DeleteCartItemBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "deleteItem", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Ref: SC_PC_71
 * 
 * SubmitOrder method gets called the AddFavOrder()
 * @param PlaceOrderBO
 */
const DeletFavItem = (deleteFavBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_DeleteFavItem,
            JSON.stringify(deleteFavBO),

            (data) => {
                if (data.success) {
                    ;
                    if (data.response != "" && data.response) {
                        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                        let contentData = { type: "ShoppingCart_DeleteFavItem", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/*[03/16/22,WAL-721_PC_03,WAL-721], Priyanka D */
const Reorder = (ReorderBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_ReorderChecker,
            JSON.stringify(ReorderBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ReorderResponse", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const addAttachmentImg = async (files) => {
    try {
        SDISVC.uploadFile(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_AttachFiles,
            "",
            files,
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NONCAT_UploadAttachments1", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const SubmitOrder = (PlaceOrderBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_BtnSubmit_Click,
            JSON.stringify(PlaceOrderBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "PlaceOrder", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * 
 * OrderPdf method gets called the OrderPlacedStatus()
 * @param OrderPDFBO
 */
const OrderPdf = (OrderPDFBO) => {
    try {
        ;
        SDISVC.receiveFileBase64(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_CartConfirmFile,
            JSON.stringify(OrderPDFBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "OrderPDF", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Reused from Non catalog request page
 * 
 * QuickItemCheck method gets called the quickItemClick()
 * @param quickItemBO
 */
const QuickItemCheck = async (quickItemBO) => {
    try {

        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_QuickItemCheck,
            JSON.stringify(quickItemBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ShopCart_QuickItemCheck", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Reused from Non catalog request page
 * 
 * addAttachment method gets called the handleAttachment()
 * @param files
 */
const addAttachment = async (files) => {
    try {
        SDISVC.uploadFile(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_AttachFiles,
            "",
            files,
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ShopCart_UploadAttachments", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Ref: NC_PC_28
 * 
 * downloadAttachment method gets called from the on clicking the title of the file
 * @param downloadBO
 */
const downloadAttachment = async (downloadBO) => {
    try {
        SDISVC.downloadFile(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_DownloadFile,
            JSON.stringify(downloadBO),
            downloadBO.fileName,
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {

                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Ref: NC_PC_29
 * 
 * removeAttachment method gets called from when clicking the remove icon of the attachment
 * @param removeBO
 */
const removeAttachment = async (removeBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_RemoveFile,
            JSON.stringify(removeBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ShopCart_RemoveAttachment", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/**
 * Ref: SC_PC_73
 * 
 * CancelOrderItem method gets called from when cancel order button is clicked
 * @param CancelOrderBO
 */
const CancelOrderItem = (CancelOrderBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ShoppingCart_btnCancel_Click,
            JSON.stringify(CancelOrderBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "CancelOrder", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
/**
 * insertFavPage method gets called on adding page to favorite
 * @param insertFavPageBO
 */
const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ShopCart_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/**
 * deleteFavPage method gets called on removing page from favorite
 * @param deleteFavPageBO
 */
const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ShopCart_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
/**
 * getCurrentFavPage method gets called on page load
 * @param getFavPageBO
 */
const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "ShopCart_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const BindHALocations = (GetLocBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.GetHallLocations,
            JSON.stringify(GetLocBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "HALocations", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    };


}

const BindPostalCodeHALocations = (GetPostalLocBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.GetPostalHallLocations,
            JSON.stringify(GetPostalLocBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "HALocations", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    };


}

const GraingerItem = (GetCartBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.GetGraingerAvailability,
            SDIConstants.methodNames.GetGraingerAvailability,
            JSON.stringify(GetCartBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "grainger", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const WorkOrderCheck = async (getFavPageBO) => {
    try {
        SDISVC.callAsync(
            SDIConstants.moduleNames.ServiceChannel,
            SDIConstants.methodNames.ServiceChannel_GetStoreData,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {

                    if (data.response != "" && data.response != "[]" && data.response != [] && data.response) {
                        let contentData = { type: "workordercheck", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                    else {
                        let contentData = { type: "workorderfail", response: "fail" };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
const WarehouseQTYCheck = async (GetCartBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.GetWarehouseAvailablity,
            JSON.stringify(GetCartBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "WarehouseQty", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
//[2/16/22], WW-330, Dhevanesam R
const WarehouseIconCheck = async (GetCartBO) => {
    try {
        ;
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.GetWarehouseAvailablity,
            JSON.stringify(GetCartBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        $(`#${SDIConstants.SDILoader}`).addClass('hide');
                        let contentData = { type: "WarehouseIcon", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
};
const FavOrderRemoveAttachments = async (removeBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.NonCatalog,
            SDIConstants.methodNames.NonCatalog_RemoveFile,
            JSON.stringify(removeBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NONCAT_RemoveAttachment_Fav_Ord", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

//Google API -Zipcode validation WW-748/782 Pavitha [4/24/2024] 
const ZipcodeValidation = (ZipcodeBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ShoppingCart,
            SDIConstants.methodNames.ZipcodeValidation,
            JSON.stringify(ZipcodeBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Zipcode_Validation", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    };


}
const HostMultipleImages = async (hostBo) => {
    try {
        SDISVC.callMobileGateway(
            SDIConstants.moduleNames.Mobile,
            SDIConstants.methodNames.Mutli_Attach_For_Form,
            JSON.stringify(hostBo),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "HostedSuccessfully", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};
//let getcontent = async () => {
//    let apiurl = "https://maps.googleapis.com/maps/api/place/textsearch/json?query=695564&key=AIzaSyBck4pWT3uHaeUzqFGS9KwwT_QUAf2O0co&sensor=false";
//    ;
//    let response = await axios.get(apiurl);
//    console.log(response);

//    ;
//    let dispatcherobj = { type: "getcontent", value: response.data.value };

//    Dispatcher.dispatch(dispatcherobj);
//}
export {
    Getcartitem, Gettrucklatlong, UpdateItemDesp, UpdateCartEmpCC, GetAddFavItemDetail,
    updateFavsMenu, DeleteCartItem, SubmitOrder, OrderPdf, CancelOrderItem, Reorder, addAttachmentImg,
    QuickItemCheck, removeAttachment, downloadAttachment, addAttachment, deleteFavPage, insertFavPage, getCurrentFavPage, BindHALocations, GraingerItem, WorkOrderCheck, DeletFavItem, WarehouseQTYCheck, WarehouseIconCheck,
    FavOrderRemoveAttachments, RatingSubmission, BindPostalCodeHALocations, HostMultipleImages, ZipcodeValidation
}